var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09082 7.50002L5.99707 4.40627L6.88082 3.52252L10.8583 7.50002L6.88082 11.4775L5.99707 10.5938L9.09082 7.50002Z",
    fill: "#AC002D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRed);
export default __webpack_public_path__ + "static/media/arrow_right_red.8ebd7097b1b4da5c44266892e6900256.svg";
export { ForwardRef as ReactComponent };